<template>
  <CustomUpdateDialog
    :dialogTitle="`تنظیم کردن کلاس گروهی ${selectedGroupClassTitle}`"
    dialogId="update-group-class-by-master-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateGroupClassByMasterRequest"
  >
    <template v-if="defaultSelectedGroupClass">
      <BCol cols="12">
        <TextInput
          inputId="masterGroupClassTitle"
          inputLabel="عنوان کلاس"
          inputPlaceholder="آیلتس تخصصی"
          v-model="updateGroupClassByMasterPayload.masterGroupClassTitle"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassDate"
          @getSelectedDate="setGroupClassDate"
          inputLabel="تاریخ کلاس"
          inputPlaceholder="1403/06/05"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassStartTime"
          :readonly="!selectedClassDate"
          :roundMinute="false"
          @getSelectedDate="setGroupClassStartTime"
          inputLabel="ساعت شروع کلاس"
          inputPlaceholder="12:30"
          type="time"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassEndTime"
          :readonly="!updateGroupClassByMasterPayload.startDate"
          :roundMinute="false"
          :jumpMinute="defaultSelectedGroupClass.duration"
          :min="updateGroupClassByMasterPayload.startDate"
          @getSelectedDate="setGroupClassEndTime"
          inputLabel="ساعت پایان کلاس"
          inputPlaceholder="14:30"
          type="time"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassDeadline"
          @getSelectedDate="setGroupClassDeadline"
          inputLabel="مهلت ثبت نام شاگرد ها"
          inputPlaceholder="1403/06/05"
          type="datetime"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomTextarea
          rows="3"
          inputId="masterGroupClassDescription"
          inputLabel="توضیحات استاد (دلخواه)"
          inputPlaceholder="توضیحات..."
          :maxChars="2000"
          customRules="max:2000"
          :charsCount="
            updateGroupClassByMasterPayload.masterGroupClassDescription
              ? updateGroupClassByMasterPayload.masterGroupClassDescription
                  .length
              : 0
          "
          v-model="updateGroupClassByMasterPayload.masterGroupClassDescription"
        ></CustomTextarea>
      </BCol>
      <BCol cols="12">
        <TextInput
          inputId="classLink"
          inputLabel="لینک کلاس (دلخواه)"
          inputPlaceholder="https://meet.google.com/XRWasdf"
          v-model="updateGroupClassByMasterPayload.groupClassLink"
        ></TextInput>
      </BCol>
    </template>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaultSelectedGroupClass: {
      type: Object,
    },
  },
  data() {
    return {
      updateGroupClassByMasterPayload: {
        groupClassMasterId: null,
        startDate: null,
        endDate: null,
        deadLine: null,
        groupClassLink: null,
        masterGroupClassDescription: null,
        masterGroupClassTitle: null,
      },
      selectedClassDate: null,
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setGroupClassStartTime(startTime) {
      this.updateGroupClassByMasterPayload.startDate = this.customSetHourOnDate(
        this.selectedClassDate,
        startTime
      )?.toISOString();
    },
    setGroupClassEndTime(endTime) {
      this.updateGroupClassByMasterPayload.endDate = this.customSetHourOnDate(
        this.selectedClassDate,
        endTime
      )?.toISOString();
    },
    setGroupClassDeadline(deadLine) {
      if (deadLine) {
        this.updateGroupClassByMasterPayload.deadLine = new Date(
          deadLine
        ).toISOString();
      }
    },
    setGroupClassDate(selectedDate) {
      if (selectedDate) {
        this.selectedClassDate = new Date(selectedDate).toISOString();
        this.selectedClassDate = new Date(selectedDate).toISOString();
      } else {
        this.selectedClassDate = null;
        this.selectedClassDate = null;
        this.updateGroupClassByMasterPayload.startDate = null;
        this.updateGroupClassByMasterPayload.endDate = null;
        this.updateGroupClassByMasterPayload.deadLine = null;
      }
    },
    setGroupClassEndtDate(endDate) {
      if (endDate) {
        this.updateGroupClassByMasterPayload.endDate = new Date(
          endDate
        ).toISOString();
      } else {
        this.updateGroupClassByMasterPayload.endDate = null;
      }
    },
    isEndTimeValid() {
      if (
        new Date(this.updateGroupClassByMasterPayload.endDate).getTime() -
          new Date(this.updateGroupClassByMasterPayload.startDate).getTime() <=
        0
      ) {
        return false;
      }
      return true;
    },
    async sendUpdateGroupClassByMasterRequest() {
      try {
        this.isOkButtonDisabled = true;

        if (!this.isEndTimeValid()) {
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "تداخل تاریخ!",
              icon: "XIcon",
              variant: "danger",
              text: "تاریخ پایان کلاس باید قبل از تاریخ شروع باشد!",
            },
          });
        }

        this.updateGroupClassByMasterPayload.groupClassMasterId =
          this.defaultSelectedGroupClass.masterGroupClass.masterDetail.id;
        let _this = this;
        let updateGroupClassByMaster = new UpdateGroupClassByMaster(_this);
        updateGroupClassByMaster.setRequestParamDataObj(
          _this.updateGroupClassByMasterPayload
        );
        await updateGroupClassByMaster.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تنظیمات کلاس گروهی با موفقیت ثبت شد.",
              },
            });
            _this.updateGroupClassByMasterPayload = {
              groupClassMasterId: null,
              startDate: null,
              endDate: null,
              deadLine: null,
              groupClassLink: null,
              masterGroupClassDescription: null,
              masterGroupClassTitle: null,
            };
            _this.$emit("refetch");
            _this.selectedClassDate = null;
            _this.$bvModal.hide("update-group-class-by-master-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    selectedGroupClassTitle() {
      if (this.defaultSelectedGroupClass) {
        return this.defaultSelectedGroupClass.name;
      }
      return "";
    },
  },
  mixins: [timeConvertUtils],
  components: {
    CustomUpdateDialog,
    CustomDatePicker,
    CustomAppendText,
    CustomTextarea,
    TextInput,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomTextarea from "@/views/components/Utils/CustomTextarea.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BCol } from "bootstrap-vue";
import { UpdateGroupClassByMaster } from "@/libs/Api/GroupClass";
</script>
